<h2 *ngIf="loading" class="loader">Loading...</h2>
<app-header *ngIf="user" [user]="user" (logout)="removeUserInfo()"></app-header>
<router-outlet *ngIf="!loading"></router-outlet>